import { ISchoolSettingsDto } from './../../../../../typings/project';
import { bindable, bindingMode } from "aurelia-framework";


export class SchoolSettingsTable {
    @bindable({ defaultBindingMode: bindingMode.twoWay })

    data: Array<ISchoolSettingsDto> = [];
    canSave: boolean;
    filteredSchoolSettings: Array<ISchoolSettingsDto> = [];
    displayData: Array<ISchoolSettingsDto> = [];
    pageSize = 50;
    filters = [{ value: "", keys: ["schoolName"] }];
    currentPage = 1;
    totalItems = 0;
    

    constructor(){}

    attached(){
        this.filteredSchoolSettings = this.data;
        this.displayData = this.data;
        this.totalItems = this.filteredSchoolSettings.length;
    }
    dataChanged(newValue: ISchoolSettingsDto[]) {
        this.filteredSchoolSettings = newValue
        this.displayData = newValue;

        this.totalItems = this.filteredSchoolSettings.length;
    }

    switchToggled(schoolId: number, newValue: boolean) {
        const schoolToggled = this.data.find(f => f.schoolId == schoolId);
        schoolToggled.display = newValue;
        if(!newValue){
            schoolToggled.displayInternal = newValue;
            schoolToggled.displayExternal = newValue;
        }else{
           if(!schoolToggled.displayInternal && !schoolToggled.displayExternal){
                schoolToggled.displayInternal = newValue;
                schoolToggled.displayExternal = newValue;
           }
        }
    }

    checkIfCanSave(school: ISchoolSettingsDto){
        if(!school.displayExternal && !school.displayInternal){
            school.display = false;
        }
    }
}